<template>
  <div class="block">
    <div class="line">
      <div class="line-name">
        发票编号：
      </div>
      <div class="line-value"
      >
      {{invoiceListDetail.invoice_no}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        物流编号：
      </div>
      <div class="line-value"
      >
      {{invoiceListDetail.logistics_no}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        开票凭证图片：
      </div>
      <div class="line-value"
       v-for="(imgList, index) in picListOne"
       :key="imgList.index"
       :value="imgList.index"
      >
        <img :src="imgList" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoiceListDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    picListOne () {
      if (this.invoiceListDetail.img_urls === null || this.invoiceListDetail.img_urls === undefined) {
        return
      }
      let arr = this.invoiceListDetail.img_urls.split(',')
      let picList = []
      console.log(arr)
      if (arr.length !== 0) {
        arr.forEach((item) => {
          picList.push(item)
        })
      }
      return this.picList
    }
  },
  watch: {
    invoiceListDetail (val) {
      console.log(val)
    }
  }
}
</script>

<style lang="less" scoped>
.block {

  .line {
    display: flex;
    padding-top: 10px;
    line-height: 20px;

    .line-name {
      width: 100px;
      font-size: 12px;
      color: #405060;
    }

    .line-value {
      width: 168px;
      margin-left: 10px;
      font-size: 12px;
      color: #80848F;
      overflow: hidden;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoiceManage/agInvoiceSearch/InvoiceDetailTop.vue